export default "__VITE_ASSET__BZrsjVqy__"